// @flow
import * as React from 'react';
import { withLeaflet } from 'react-leaflet';
import {
    injectIntl, defineMessages, type IntlShape,
} from 'react-intl';
import type { LeafletContext } from 'react-leaflet/lib/types';
import { CONTENT_BOXES_MIN_ZOOM } from 'esm-web-pro/containers/pages/network/NetworkTab';
import MoreInfo from 'esm-web-pro/assets/images/map/MoreInfo.svg';
import NoInfo from 'esm-web-pro/assets/images/map/noInfo.svg';
import ReactTooltip from 'react-tooltip';
import LabelText from 'esm-web-pro/components/layout/sidePanel/LabelText';

type Props = {
    leaflet: LeafletContext,
    intl: IntlShape,
}

const messages = defineMessages({
    showInfo: {
        id: 'networks-map-show-info',
        defaultMessage: 'Show content info',
    },
});

type State = {
    showContent: boolean,
}

@withLeaflet
@injectIntl
class ShowContentControl extends React.Component<Props, State> {
    control: Object;

    active = false;

    static defaultProps = {
        leaflet: {},
        intl: {},
    };

    constructor(props: Props) {
        super(props);

        this.state = {
            showContent: true,
        };
    }

    componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS) {
        const { leaflet: { map } } = prevProps;
        const { showContent } = this.state;

        if (showContent && map.getZoom() < CONTENT_BOXES_MIN_ZOOM) {
            map.getContainer().classList.add('map-hide-content-boxes');
        } else if (showContent && map.getZoom() >= CONTENT_BOXES_MIN_ZOOM && showContent) {
            map.getContainer().classList.remove('map-hide-content-boxes');
        }
    }

    toggleShowContent = (e: SyntheticMouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();

        const { leaflet: { map } } = this.props;
        const { showContent } = this.state;

        if (showContent) {
            map.getContainer().classList.add('map-hide-content-boxes');
        } else {
            map.getContainer().classList.remove('map-hide-content-boxes');
        }
        this.setState((prevState) => ({ showContent: !prevState.showContent }));
    };

    render() {
        const { leaflet: { map }, intl: { formatMessage } } = this.props;
        const { showContent } = this.state;

        return map.getZoom() >= CONTENT_BOXES_MIN_ZOOM ? (
            <div className="leaflet-bar networks-additional-control">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                    href="#"
                    title={formatMessage[messages.showInfo]}
                    role="button"
                    aria-label={formatMessage[messages.showInfo]}
                    onClick={this.toggleShowContent}
                    data-tip
                    data-for="map-show-content-control-tooltip"
                >
                    <img src={showContent ? MoreInfo : NoInfo} alt="content-info-icon" />
                </a>
                <ReactTooltip
                    id="map-show-content-control-tooltip"
                    effect="solid"
                    place="right"
                    className="react-tooltip"
                >
                    <LabelText>
                        {showContent ? formatMessage(
                            { id: 'hide-content-control', defaultMessage: 'Hide content' },
                        ) : formatMessage(
                            { id: 'show-content-control', defaultMessage: 'Show content' },
                        )}
                    </LabelText>
                </ReactTooltip>
            </div>
        ) : null;
    }
}

export default ShowContentControl;
